import { render, staticRenderFns } from "./VacancySearchWrapper.vue?vue&type=template&id=0607f5d0&"
import script from "./VacancySearchWrapper.vue?vue&type=script&lang=ts&"
export * from "./VacancySearchWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports